/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteOrderDetailsCommand } from '../../models/delete-order-details-command';
import { DeleteOrderDetailsCommandResult } from '../../models/delete-order-details-command-result';

export interface ApiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Params {
      body?: DeleteOrderDetailsCommand
}

export function apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderDetailsDeleteOrderDetailsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteOrderDetailsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteOrderDetailsCommandResult>;
    })
  );
}

apiNurseryManagerOrderDetailsDeleteOrderDetailsDelete.PATH = '/api/NurseryManager/OrderDetails/DeleteOrderDetails';
